import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import GroupsList from './GroupList';

//redux

const WarehouseGroups = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Bodega', icon: 'icon-warehouse' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Grupo' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<GroupsList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default WarehouseGroups;
